// Marketing top-nav + footer chrome for the Investor Deal Analyzer page.
// Duplicated from FreeToolsPage/SellerNetSheet Layout patterns — shared-nav
// extraction remains backlog per hard guardrail.

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../../components/Footer';

function IdaNav() {
  const navigate = useNavigate();
  return (
    <nav
      className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50"
      data-testid="ida-nav"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <img
              src="https://customer-assets.emergentagent.com/job_agent-portal-27/artifacts/azdcmpew_Logo_with_brown_background-removebg-preview.png"
              alt="I Need Numbers"
              className="h-8 w-auto"
            />
            <span
              className="text-lg font-bold text-[#2FA163] tracking-wide"
              style={{ fontFamily: 'Playfair Display, Georgia, serif' }}
            >
              I NEED NUMBERS
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-6">
            <button type="button" onClick={() => navigate('/features')} className="text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium">Features</button>
            <button type="button" onClick={() => navigate('/free-tools')} className="text-[#16a34a] text-sm font-semibold">Free Tools</button>
            <button type="button" onClick={() => navigate('/pricing')} className="text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium">Pricing</button>
            <button type="button" onClick={() => navigate('/blog')} className="text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium">Blog</button>
            <button type="button" onClick={() => navigate('/support')} className="text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium">Support</button>
            <button
              type="button"
              onClick={() => navigate('/auth/register')}
              data-testid="ida-nav-trial-btn"
              className="bg-[#16a34a] hover:bg-[#0d7a36] text-white font-semibold px-5 py-2 rounded-lg transition-all"
            >
              Start Free Trial
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: '#F7F5EE' }}>
      <IdaNav />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
